<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">

                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <div>
                                    <img class="app-icon" src="/img/apps/tip/app_icon.png" alt="Ping App Icon">
                                    <h1 class="display-3">
                                        Tip – Tip Calculator
                                        <span>Tip is an emjoi fueled tip calculator {{currentEmoji}}</span>
                                    </h1>
                                </div>
                                <p class="lead">
                                  Math can be hard and especially at the dinner table you should spend your time differently. 
                                  Just enjoy your meal and once the bill is ready, <strong>Tip</strong> will help you to give a fair Tip to your waiter.
                                </p>
                                <div class="btn-wrapper">
                                    <a href="https://frhlch.at/f/tip?app=1" target="_blank">
                                        <img width="150" src="/img/app/download_appstore.png" alt="Download Tip on the App Store">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <app-showcase 
                                    imageSrc="/img/apps/tip/tip_placeholder.png" 
                                    videoSrc="https://www.dropbox.com/s/s78ck2ueqcg1q7o/tip_showcase_scaled.mp4?dl=1" 
                                    posterSrc="/img/apps/tip/tip_video_placeholder.png"
                                    class="floating"
                                    >
                                </app-showcase>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

    <div class="bottom-spacer"></div>

    </div>
</template>

<script>
export default {
  name: "Tip",
  components: {},
  data() {
    return {
      emojiString: [
        "😀",
        "😃",
        "😄",
        "😁",
        "😆",
        "😂",
        "🤣",
        "😊",
        "😇",
        "🙂",
        "🙃",
        "😉",
        "😌",
        "😍",
        "😗",
        "😘",
        "😙",
        "😚",
        "😋",
        "😛",
        "😜",
        "😎",
        "🤩",
        "😏",
        "😳",
        "😤",
        "😮",
        "😬",
        "🤢",
        "😵",
        "👿",
        "💩",
        "👻",
        "✌️",
        "🙏",
        "☝️",
        "💪"
      ],
      currentEmoji: ""
    };
  },
  mounted() {
    this.updateEmojiString();
    setInterval(this.updateEmojiString, 7500);
  },
  methods: {
    updateEmojiString() {
      let numberOfEmoji = 3 + Math.floor(Math.random() * 2);
      let newEmoji = "";

      for (let i = 0; i < numberOfEmoji; i++) {
        newEmoji += this.emojiString[
          Math.floor(Math.random() * this.emojiString.length)
        ];
      }
      this.currentEmoji = newEmoji;
    }
  }
};
</script>

<style scoped lang="css">
    .no-pointer-events {
        pointer-events: none;
    }

    h1 {
        display: inline-grid;
    }

    h1 span {
        font-size: 1.5rem;
        color: rgba(0,0,0,0.7);
    }

    .app-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        display: inline-grid;
        margin-right: 15px;
        margin-top: 10px;
    }

    .app-showcase {
        width: 350px;
        height: 700px;
        margin: auto;
        margin-top: 60px;
    }

    @media (min-width: 992px) {
        .app-showcase {
            position: absolute;
            top: -65px;
            right: 0;
        }
    }


    .section-shaped .shape-style-1.shape-default {
        background: linear-gradient(150deg, #FAD860 15%, #F8C53B 70%, #F7BC2E 94%);
    }

    .bottom-spacer {
        margin-bottom: 300px;
    }

</style>
